import $ from 'jquery'
import { isSP } from './checkScreen'

const jsTelSP = () => {
  const $jsTel = $('.js-tel')

  if ($jsTel.length) {
    $jsTel.each((index, el) => {
      const $this = $(el)

      if (isSP()) {
        const telNo = $this.text()
        telNo.replace('-', '')
        $this.replaceWith(`<a href="tel:${telNo}" class="js-tel">${$this.text()}</a>`)
      } else {
        $this.replaceWith(`<span class="js-tel">${$this.text()}</span>`)
      }
    })
  }
}

const initJsTelSp = () => {
  $(window).on('load resize', () => {
    jsTelSP()
  })
}

export default initJsTelSp
